import { LogData } from '@1js/ai-hub-telemetry';
import { RouterStatsContext } from '@office-start/telemetry-service';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { createAndInitializeModuleLogger } from './AiHubTelemetryService';
// this react hook creates a module logger for the AI Hub telemetry service
export function useAiHubModuleLogger(sec, name, moduleSessionId, getStartTime) {
    var routeStats = React.useContext(RouterStatsContext);
    var location = useLocation();
    var logger = React.useMemo(function () {
        var _a, _b, _c, _d;
        var telemetryConfiguration = (_b = (_a = sec === null || sec === void 0 ? void 0 : sec.hostContext) === null || _a === void 0 ? void 0 : _a.telemetry) === null || _b === void 0 ? void 0 : _b.telemetryConfiguration;
        if (!telemetryConfiguration) {
            return undefined;
        }
        var logger = createAndInitializeModuleLogger(telemetryConfiguration, name, moduleSessionId);
        logger === null || logger === void 0 ? void 0 : logger.setPersistentDataField(new LogData('ElapsedTimeSinceNavigate', getStartTime()));
        logger === null || logger === void 0 ? void 0 : logger.setPersistentDataField(new LogData('InitialLoad', (_c = routeStats === null || routeStats === void 0 ? void 0 : routeStats.isInitialLoad(location.pathname)) !== null && _c !== void 0 ? _c : 'false'));
        logger === null || logger === void 0 ? void 0 : logger.setPersistentDataField(new LogData('InitialVisit', (_d = routeStats === null || routeStats === void 0 ? void 0 : routeStats.isInitialVisit(location.pathname)) !== null && _d !== void 0 ? _d : 'false'));
        return logger;
    }, [moduleSessionId, name]);
    return logger;
}
//# sourceMappingURL=useAiHubModuleLogger.js.map